import React, { Component } from "react";
import PropTypes from "prop-types";
import { Collapse, Row, Col } from "reactstrap";

import { UpDownCaretArrow } from "components";

import "./index.css";

class CollapsableTableRow extends Component {
  state = {
    isCollapse: false
  };

  handleToggle = () => {
    this.setState(prevState => ({ isCollapse: !prevState.isCollapse }));
  };

  render() {
    const { isCollapse } = this.state;
    const { dataObject } = this.props;

    return (
      <>
        {/* {dataObject.map((details, index) => ( */}
        <Row className="data-subheader" onClick={this.handleToggle}>
          <Col className="data-type">{dataObject.name}</Col>
          <Col className="data-type">{dataObject.state}</Col>
          <Col className="data-type">{dataObject.operator}</Col>
          <Col className="data-type">{dataObject.amount}</Col>
          <Col className="data-type">{dataObject.totalUnit}</Col>
          <Col className="data-type" xs="auto">
            <UpDownCaretArrow isCollapse={isCollapse} />
          </Col>
        </Row>
        {/* ))} */}

        {/* {dataObject.map((details, index) => ( */}
        <Collapse isOpen={isCollapse}>
          <Row className="data-row">
            {/* {isFirstColEmpty && <Col className="data-type">&nbsp;</Col>} */}
            <Col className="data-type">Date: {dataObject.startDate}</Col>
            <Col className="data-type">Total Amount: {dataObject.amount}</Col>
            <Col className="data-type">
              Last Download: {dataObject.lastDownload}
            </Col>
          </Row>
        </Collapse>
        {/* ))} */}
      </>
    );
  }
}
CollapsableTableRow.propTypes = {
  dataObject: PropTypes.array,
  isFirstColEmpty: PropTypes.bool
};

export default CollapsableTableRow;
